import styled from 'styled-components';

export const Header = styled.header`
    font-family: 'Playfair Display', serif;
    padding: 4rem 0;

    @media(max-width: 450px) {
        padding: 4rem 0 2rem 0;
    }
`;

export const FlexHead = styled.div`
    align-items: flex-end;
    display: flex;
    justify-content: space-between;
    border-bottom: 5px double black;
    padding: 1rem 0;
`;

export const Title = styled.h1`
    font-size: 5rem;
    flex-grow: 1;
    text-align: center;
    margin: 0;
`;

export const DateSpan = styled.span`
    font-size: 1.8rem;
`;